//external
import React from 'react';
import { connect } from 'react-redux';
import { transform } from 'ol/proj';

//components
import OLLayerMap from './OLLayerMap';
import * as olStyles from './olStyles';

//actions and calls
import { pullAssignedTurfs } from '../../store/api/calls';
import { updateDoorCrew } from '../../store/actions';
import api from '../../store/api/api';
import FeedbackTile from '../theme/modals/FeedbackTile';

class TurfDropoffMapModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      layers: [],
      canvassers: [],
      selectedCanvasser: 0,
      allAssigned: false,
      loading: true,
    };
  }

  componentDidMount() {
    let { crews, shift, crew: crew_id } = this.props;
    if (!shift) {
      console.error('No shift id was passed to the dropoff modal props.');
    }

    pullAssignedTurfs({ shift: this.props.shift, cb: crypto.randomUUID() }).then((data) => {
      console.log('data', data);
      if (!crew_id && data.length) {
        crew_id = data[0].crew_id;
      }
      const localCanvassers = crews.find((d) => d.id === crew_id).seats;
      console.log('localCanvassers', localCanvassers);
      let canvassers = data.filter((d) => d.crew_id === crew_id);

      let selectedCanvasser = 0;
      if (canvassers.length)
        selectedCanvasser = (canvassers.find((d) => !d.dropoff_lat) || canvassers[0]).canvasser_id;
      this.setState({ canvassers, selectedCanvasser }, this.buildMapLayers);
    });
  }

  getColorFromQualitativeScheme = (idx) => {
    const qualitative = [
      '#33a02c',
      '#1f78b4',
      '#6a3d9a',
      '#a6cee3',
      '#fb9a99',
      '#e31a1c',
      '#fdbf6f',
      '#b2df8a',
      '#ff7f00',
      '#cab2d6',
      '#ffff99',
      '#b15928',
    ];

    return qualitative[idx % qualitative.length];
  };

  buildMapLayers = () => {
    let { canvassers } = this.state;
    let layers = [];

    canvassers.forEach((d) => {
      let fill = this.getColorFromQualitativeScheme(d.canvasser_id);
      let layer_id = `${d.canvasser_id}-points`;
      let features = d.targethouseholds.map((d) => ({
        ...d,
        layer_id,
        style: olStyles.genericSquareStyle({ fill }),
      }));

      // add points

      layers.push({
        features,
        featureType: 'points', // can be 'points', 'convex_hull', 'line_string'
        id: layer_id,
      });

      //add convex hulls
      layer_id = `${d.canvasser_id}-convexhull`;
      layers.push({
        features,
        featureType: 'convex_hull',
        groupBy: 'turf_name',
        getGroupedFeatureStyle: () => olStyles.coloredPolygonStyle(fill, 3, 0.8),
        id: layer_id,
      });

      //add dropoff point if present
      if (d.dropoff_lat) {
        layer_id = `${d.canvasser_id}-dropoff`;
        let newLayerFeatures = [
          {
            longitude: d.dropoff_lon,
            latitude: d.dropoff_lat,
            layer_id,
            style: olStyles.centroidStyle({ fill, radius: 8 }),
          },
        ];

        layers.push({
          features: newLayerFeatures,
          featureType: 'points',
          id: layer_id,
        });
      }
    });

    this.setState({ layers, loading: false });
  };

  // assign the canvasser dropoff coordinates
  handleMapClick = (olEvt) => {
    let lonlat = olEvt.coordinate && transform(olEvt.coordinate, 'EPSG:3857', 'EPSG:4326');
    let longitude = lonlat ? lonlat[0].toFixed(6) : null;
    let latitude = lonlat ? lonlat[1].toFixed(6) : null;

    let canvassers = this.state.canvassers.map((d) =>
      d.canvasser_id === this.state.selectedCanvasser
        ? { ...d, dropoff_lat: +latitude, dropoff_lon: +longitude }
        : d
    );

    let canvasser = this.state.canvassers.find(
      (d) => d.canvasser_id === this.state.selectedCanvasser
    );

    let newLayerId = `${canvasser.canvasser_id}-dropoff`;

    let layers = this.state.layers.filter((d) => d.id !== newLayerId);
    let canvasserFill = this.getColorFromQualitativeScheme(this.state.selectedCanvasser);
    let newLayerFeatures = [
      {
        longitude,
        latitude,
        layer_id: newLayerId,
        style: olStyles.genericCircleStyle({ fill: canvasserFill, radius: 8 }),
      },
    ];

    longitude &&
      layers.push({
        features: newLayerFeatures,
        featureType: 'points',
        id: newLayerId,
      });

    /*
     * the coordinates need to be updated in three places:
     *
     *
     *  1) State, so that we draw the dropoff lat/lon on the map and handle any side effects
     *  2) The crewcanvasser table on the database, which is where the data persists
     *  3) The doorcrew redux reducer, so that side effects and displays can be handled on the scheduler page without reload
     *
     * */
    this.setState({ layers, canvassers }, () => {
      let nextCanvasser = this.state.canvassers.find((d) => !d.dropoff_lat);
      if (nextCanvasser) {
        this.setState({ selectedCanvasser: nextCanvasser.canvasser_id });
      } else {
        this.setState({ allAssigned: true });
      }
    });

    // update in database
    api
      .patch(`/doorcrewcanvassers/${canvasser.crewcanvasser_id}/`, {
        dropoff_lat: latitude,
        dropoff_lon: longitude,
      })
      .then((res) => {
        //api call returns updated crew canvasser. The last step in the process is too update this in doorcrewcanvasser reducer
        //We need to replace the seat and call update crew

        let crew = this.props.crews.find((d) => d.id === canvasser.crew_id);

        if (!crew) console.log('ERROR ERROR no crew found');
        let seatIndex = crew.seats.findIndex((d) => d.id === canvasser.crewcanvasser_id);
        crew.seats[seatIndex].dropoff_lat = res.data.dropoff_lat;
        crew.seats[seatIndex].dropoff_lon = res.data.dropoff_lon;

        this.props.updateCrew(crew);
      });
  };

  handleCanvasserCardMouseOver = (canvasserData) => {
    let { canvasser_id } = canvasserData;
    let layers = [...this.state.layers];
    let convexHullLayer = this.state.layers.find((d) => d.id === `${canvasser_id}-convexhull`);
    if (!convexHullLayer) return;
    let fill = this.getColorFromQualitativeScheme(canvasser_id);
    convexHullLayer = {
      ...convexHullLayer,
      getGroupedFeatureStyle: () => olStyles.coloredPolygonStyle(fill, 9, 1),
      id: 'hover-convex-hull',
    };

    layers = [...layers, convexHullLayer];
    this.setState({ layers });
  };

  handleCanvasserCardMouseOut = () => {
    let layers = [
      ...this.state.layers.filter((d) => d.id !== 'hover-convex-hull' && d.id !== 'hover-point'),
    ];
    this.setState({ layers });
  };

  handlePointMouseOver = (pointData) => {
    let { layer_id, latitude, longitude } = pointData;
    let layers = [...this.state.layers];
    let pointLayer = this.state.layers.find((d) => d.id === layer_id);
    console.log(pointLayer, 'pointLayer');
    if (!pointLayer) return;
    let fill = this.getColorFromQualitativeScheme(pointLayer.id.split('-')[0]);
    pointLayer = {
      ...pointLayer,
      features: [
        {
          ...pointLayer.features[0],
          style: olStyles.genericCircleStyle({ fill, radius: 10 }),
        },
      ],
      id: 'hover-point',
    };
    layers = [...layers, pointLayer];
    console.log('layers', layers);
    this.setState({ layers });
  };

  handleFeatureHover = (marker) => {
    console.log(marker);
    if (marker && marker.id) {
      this.handleCanvasserCardMouseOver({ canvasser_id: marker.id.split('-')[0] });
    } else if (marker && marker.layer_id) {
      this.handlePointMouseOver(marker);
    } else {
      this.handleCanvasserCardMouseOut();
    }
  };

  unassignCanvasser = (id) => {
    this.setState({ selectedCanvasser: id }, () => {
      this.handleMapClick({});
      this.setState({ selectedCanvasser: null });
    });
  };

  renderCanvasserCards = () => {
    return this.state.canvassers
      .sort((d) => (d.canvasser_id === this.state.selectedCanvasser ? -1 : 0))
      .map((d) => {
        let color = this.getColorFromQualitativeScheme(d.canvasser_id);
        let selected = d.canvasser_id === this.state.selectedCanvasser;
        return (
          <div
            className={`canvasser-card ${selected ? 'selected' : ''}`}
            key={d.canvasser_id}
            style={{
              borderLeftColor: color,
            }}
            onClick={() => this.setState({ selectedCanvasser: d.canvasser_id })}
            onMouseEnter={() => this.handleCanvasserCardMouseOver(d)}
            onMouseLeave={() => this.handleCanvasserCardMouseOut()}
          >
            <span className={'canvasser-name'}>
              {d.firstname} {d.lastname}
            </span>
            {!!d.dropoff_lat && (
              <>
                <div className={'success-text'}>
                  <i className={'fa fa-check-circle'} /> Assigned
                </div>

                <button
                  onClick={() => this.unassignCanvasser(d.canvasser_id)}
                  className="button button-clear danger-text p-0 mt-2"
                >
                  <i className={'fa fa-times-circle'} /> Unassign
                </button>
              </>
            )}
          </div>
        );
      });
  };

  render() {
    return (
      <div className={'map-modal'}>
        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this.state.loading}
        />

        <div className={'map-modal__map'}>
          <OLLayerMap
            layers={this.state.layers}
            onClick={this.handleMapClick}
            onMarkerHover={this.handleFeatureHover}
          />
          <div className={'map-modal__sidebar'}>
            <div className={'map-modal__sidebar__title'}>
              <h3 className={'primary-text'}>Dropoff Points</h3>
              <h5 className={'primary-text'}>Crew {this.props.crew}</h5>
            </div>
            {this.renderCanvasserCards()}

            {!!this.state.canvassers.length && this.state.canvassers.every((d) => d.dropoff_lat) && (
              <div className={'map-modal__sidebar__success-msg'}>
                <i className={'fa fa-check-circle'} /> All Assigned
              </div>
            )}

            <div className={'map-modal__sidebar__close-button'}>
              <div className={'button button-outline'} onClick={this.props.onClose}>
                I&apos;m done
              </div>
            </div>
          </div>
        </div>
        <div className={'map-modal__close-button'} onClick={this.props.onClose}></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  crews: state.doorCrews.data,
  loading: state.doorCrews.loading,
  error: state.doorCrews.error,
});

const mapDispatchToProps = (dispatch) => ({
  updateCrew: (data) => dispatch(updateDoorCrew(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TurfDropoffMapModal);
